import SignalCellularConnectedNoInternet0BarIcon from '@mui/icons-material/SignalCellularConnectedNoInternet0Bar';
import SignalCellularConnectedNoInternet1BarIcon from '@mui/icons-material/SignalCellularConnectedNoInternet1Bar';
import SignalCellularConnectedNoInternet2BarIcon from '@mui/icons-material/SignalCellularConnectedNoInternet1Bar';
import SignalCellularConnectedNoInternet3BarIcon from '@mui/icons-material/SignalCellularConnectedNoInternet1Bar';
import SignalCellularConnectedNoInternet4BarIcon from '@mui/icons-material/SignalCellularConnectedNoInternet1Bar';
import {AppBar, Toolbar, Dialog, Grid, Typography, IconButton} from '@mui/material';
import SignalCellular0BarIcon from '@mui/icons-material/SignalCellular0Bar';
import SignalCellular1BarIcon from '@mui/icons-material/SignalCellular1Bar';
import SignalCellular2BarIcon from '@mui/icons-material/SignalCellular2Bar';
import SignalCellular3BarIcon from '@mui/icons-material/SignalCellular3Bar';
import SignalCellular4BarIcon from '@mui/icons-material/SignalCellular4Bar';
import CloseIcon from '@mui/icons-material/Close';
import {useTranslation} from "react-i18next";
import {observer} from 'mobx-react';
import {useState} from 'react';
import {useGlobalStorage} from './mobx/GlobalStorage.js';

const ConnDialog = observer((props) => {
	const gStorage = useGlobalStorage();
	const {isOpen, handleClose} = props;
	const {t} = useTranslation('obs');

	return (
		<Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={isOpen ? true : false} PaperProps={{sx: {margin: 0, padding: 0}}}>
			<Grid container direction="row" justifyContent="center" alignItems="center" spacing={0} style={{width:316}}>
				<AppBar position="sticky">
					<Toolbar variant="dense">
						<Typography variant="h6" style={{flexGrow: 1, textAlign: 'center'}}>{t('connection.connection')}</Typography>
						<IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
							<CloseIcon />
						</IconButton>
					</Toolbar>
				</AppBar>

				<Grid size={{xs: 12}} align={'center'}>
					<div style={{margin: 5, marginTop: 10}}>{t('connection.level') + ': ' + gStorage.conn.conn_level + ' %'}</div>
				
					{navigator.connection && 
						<>
						<div style={{margin: 5}}>{t('connection.type') + ': ' + navigator.connection.effectiveType}</div>
						<div style={{margin: 5}}>{t('connection.downlink') + ': ' + navigator.connection.downlink + ' Mb/s'}</div>
						<div style={{margin: 5}}>{t('connection.rtt') + ': ' + navigator.connection.rtt + ' ms.'}</div>
						</>
					}

					{gStorage.conn.meas_conn_delay !== '--' ? 
						<div style={{margin: 5, marginBottom: 10}}>{t('connection.measured_rtt') + ': ' + gStorage.conn.meas_conn_delay + ' ms.'}</div> :
						<div style={{margin: 5, marginBottom: 10, color: 'red'}}>{t('connection.no_server_connection') + '!'}</div>
					}
				</Grid>
			</Grid>
		</Dialog>
	);
});

const ConnLevelButton = observer((props) => {
	const [connDialogVisible, setConnDialogVisible] = useState(false);
	const gStorage = useGlobalStorage();

	function connSymbol() {
		const level = gStorage.conn.conn_level;

		if (level === 0) {
			if (gStorage.conn.meas_conn_delay === '--')
				return <SignalCellularConnectedNoInternet0BarIcon style={{color: 'crimson'}}/>;

			return <SignalCellular0BarIcon style={{color: 'crimson'}}/>;
		} else if (level < 33) {
			if (gStorage.conn.meas_conn_delay === '--')
				return <SignalCellularConnectedNoInternet1BarIcon style={{color: 'pink'}}/>;
				
			return <SignalCellular1BarIcon style={{color: 'pink'}}/>;
		} else if (level < 66) {
			if (gStorage.conn.meas_conn_delay === '--')
				return <SignalCellularConnectedNoInternet2BarIcon style={{color: 'pink'}}/>;

			return <SignalCellular2BarIcon style={{color: 'pink'}}/>;
		} else if (level < 100) {
			if (gStorage.conn.meas_conn_delay === '--')
				return <SignalCellularConnectedNoInternet3BarIcon style={{color: 'pink'}}/>;

			return <SignalCellular3BarIcon style={{color: 'mistyrose'}}/>;
		} else {
			if (gStorage.conn.meas_conn_delay === '--')
				return <SignalCellularConnectedNoInternet4BarIcon style={{color: 'pink'}}/>;

			return <SignalCellular4BarIcon style={{color: 'seashell'}}/>;
		}
	}

	function connIconClick() {
		/* Unfocus clicked button to prevent aria-hidden warnings. */
		document.activeElement.blur();

		setConnDialogVisible(true);
	}

	function connDialogClose() {
		setConnDialogVisible(false);
	}

	return (
		<>
			<IconButton size="small" onClick={connIconClick}>
				{connSymbol()}
			</IconButton>

			<ConnDialog isOpen={connDialogVisible} handleClose={connDialogClose} />
		</>
	);
});

export default ConnLevelButton;
